import { FC, useState } from 'react';
import { message, Modal, Button } from 'antd';
import { useAppDispatch } from '../../methods/redux/hooks';
import { unbindTelegramId } from '../../methods/redux/reducers/user-profile';

interface IUnbindTelegramModal {
	details: { profile: { email: string } };
	setRefresh: Function;
}
const UnbindTelegramModal: FC<IUnbindTelegramModal> = ({
	details,
	setRefresh,
}) => {
	const dispatch = useAppDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = async () => {
		try {
			setIsLoading(true);
			await dispatch(unbindTelegramId({ email: details?.profile?.email }));
			setRefresh(Math.random());
		} catch (error) {
			message.error('Failed to unbind telegram');
			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}
	};

	const confirm = () => {
		Modal.confirm({
			title: 'Are you sure you want to unbind Telegram?',
			onOk() {
				handleSubmit();
			},
		});
	};
	return (
		<Button
			onClick={() => {
				confirm();
			}}
			type="primary"
			size="small"
			disabled={isLoading}
		>
			{isLoading ? 'Loading...' : 'Unbind Telegram'}
		</Button>
	);
};

export default UnbindTelegramModal;
